module.exports = __webpack_public_path__ + "static/img/no7.efa568a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no7.jpg
// module id = 1gKD
// module chunks = 31